// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"WhatToExpectCard-module__paragraph___1CLjx","office":"WhatToExpectCard-module__office___3owHP","caption":"WhatToExpectCard-module__caption___1XXvh"};